<template>
  <div
    class="learn-home d-flex flex-column justify-content-center  align-items-center bd-highlight mb-3"
    style="margin-top:150px"
  >
    <job-card :job="job" class="w-75" />
  </div>
</template>

<script>
import JobCard from "../components/Utilities/Cards/Job.vue";
import axios from "axios";
export default {
  name: "JobDetail",
  components: { JobCard },
  data: () => {
    return {
      job: {},
    };
  },
  created() {
    this.getJob();
  },
  methods: {
    async getJob() {
      await axios
        .get(`https://api.ardunic.com/v1/jobs/${this.$route.params.id}`)
        .then((res) => {
          this.job = res.data.data;
        });
    },
  },
};
</script>

<style scoped>
.cart {
  margin-top: 120px;
}

.title h4 {
  font-weight: bolder;
}

#chipss {
  background: linear-gradient(right, #ff3fbb, #ff8891);
  border-radius: 60%;
  width: 25px;
  text-align: center;
}

#chipss2 {
  background: linear-gradient(to right, #05cefc, #5659ce);
  border-radius: 60%;
  width: 25px;
  text-align: center;
}

.items-card {
  width: 100%;
  border-radius: 20px;
  border: 1px solid #c1c2c5;
}

.left-wing {
  display: flex;
  align-items: center;
}

.right-wing {
  margin-right: 15px;
}

.price h5 {
  color: rgb(26, 91, 211);
  text-align: right;
  font-size: 20px;
  font-weight: bolder;
}

.item-title h5 {
  font-weight: bold;
  margin-bottom: 15px;
}

.item-stock {
  font-size: 18px;
  letter-spacing: 1.6;
}
.info {
  margin-left: 10px;
}

.cart-buttons {
  width: 100%;
  padding: 20px 50px;
  border-radius: 30px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
}

.contnue-button {
  width: 100%;
  text-align: center;
  padding: 20px 50px;
  border-radius: 10px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
  background: linear-gradient(to right, #09f7ff, #05f040);
  color: #fff;
}

.total-card {
  width: 50%;
  text-align: center;
  padding: 10px 50px;
  border-radius: 30px;
  border: none;
  font-size: 20px;
  font-weight: bolder;
  background: linear-gradient(to left, #05cefc, #5659ce);
  color: #fff;
}

.options-btn {
  width: 100px;
  border-radius: 30px;
  border: none;
  margin-left: 5px;
  background: #fff;
  border: 1px solid #c1c2c5;
}

.options {
  display: flex;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 10px 20px 10px;
}

.cart-item:not(:last-child) {
  border-bottom: 1px solid #c1c2c5;
}

.img-container {
  width: 250px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-container img {
  padding: 15px;
}

.my-address {
  font-weight: bolder;
}

.payment-card {
  width: 100%;
  height: 100px;
  background: linear-gradient(to left, #ff4254, #f177fd);
  color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-price-second {
  color: black;
}

.payment-card-second {
  width: 100%;
  height: 100px;
  color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 15px;
  border: 1px solid #c1c2c5;
}
</style>
